import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-not-found-error",
  standalone: true,
  imports: [],
  templateUrl: "./not-found-error.html",
  styleUrl: "./not-found-error.scss",
})
export class NotFoundError {
  constructor(private router: Router) {}

  goHome() {
    window.location.href = "/";
  }
}
